var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cotacoes container-fluid" }, [
    _vm._m(0),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "select" },
      [
        _c("v-autocomplete", {
          staticClass: "input",
          attrs: {
            items: _vm.selection,
            "no-data-text": "Sem registros",
            "item-text": _vm.getTitle,
            "return-object": "",
            "item-value": "id",
            "menu-props": { bottom: true, offsetY: true },
            placeholder: "Selecione um ativo existente",
            color: "secondary",
            required: "",
            outlined: "",
            rounded: ""
          },
          on: {
            change: function($event) {
              return _vm.changeAtivo($event)
            }
          },
          model: {
            value: _vm.ativo,
            callback: function($$v) {
              _vm.ativo = $$v
            },
            expression: "ativo"
          }
        })
      ],
      1
    ),
    _c("div", { staticClass: "upload" }, [
      _c("input", {
        ref: "uploadBox",
        attrs: { type: "file", disabled: _vm.disableSelection() },
        on: { change: _vm.uploadQuotes }
      })
    ]),
    _vm.message
      ? _c("div", { staticClass: "message" }, [_vm._v(_vm._s(_vm.message))])
      : _vm._e(),
    _vm.errorMessage
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.errorMessage))])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("Verificar e atualizar cotações de ativos.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "subtitle" }, [
      _c("span", [_vm._v("Escolha um ativo para a operação.")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }